import React, { useEffect } from 'react';
import { FormField, FormHelp, Input } from '@zillow/constellation';
import { Label } from '@zillow/constellation';
import { useField } from 'formik';
import { useGetBankWireRoutingNumberQuery } from '../../../../../../../API/order/escrow/WireDisbursementAPI';
import styled from 'styled-components';

export const INVALID_ABA_NUMBER_ERROR = 'Invalid ABA Number';

export const WireABAField: React.FC<{ isReadOnly: boolean }> = ({ isReadOnly }) => {
  const [field, meta, helpers] = useField<string>({ name: 'value.routingNumber' });
  const { data: bankName, isError: isRoutingNumberError } = useGetBankWireRoutingNumberQuery(field.value ?? '', {
    skip: field.value?.length !== 9,
  });

  useEffect(() => {
    if (isRoutingNumberError && !meta.error) {
      helpers.setError(INVALID_ABA_NUMBER_ERROR);
    }
  }, [field.value, meta.error, helpers, isRoutingNumberError]);

  return (
    <StyledFormField
      label={<Label>Wire ABA</Label>}
      control={<Input {...field} autoComplete={'off'} required />}
      error={!!meta.error}
      description={<FormHelp>{meta.error ?? bankName?.name}</FormHelp>}
      required
      readOnly={isReadOnly}
      data-test-id={'value.routingNumber-form-cell'}
    />
  );
};

const StyledFormField = styled(FormField)`
  flex-basis: 33%;
  padding-right: 2rem;
`;
